export default __webpack_public_path__ + "static/media/001-M-veuve.22f49a1b.svg";